import React from 'react';
import {
  withStyles,
  MuiThemeProvider,
  createMuiTheme,
} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import Done from '@material-ui/icons/Done';
import Check from '@material-ui/icons/Check';

import StaffListTableHead from './StaffListTableHead';
import { colors } from '@peachjar/components';

const { mercury } = colors;

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  tableWrapper: {
    width: '100%',
    overflowX: 'auto',
    border: `solid 1px ${mercury}`,
    borderRadius: '3px',
  },
  row: {
    '&:nth-of-type(even)': {
      backgroundColor: '#f5f5f5',
    },
  },
  cell: {
    textAlign: 'left',
    paddingLeft: '20px',
  },
});

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#3a833c',
      dark: '#3a833c',
      light: '#3a833c',
      contrastText: '#3a833c',
    },
  },
});

function isTrue(value) {
  const trueValues = ['yes', 'y', true];

  if (trueValues.indexOf(value) > -1) {
    return true;
  }

  return false;
}

// eslint-disable-next-line react/no-multi-comp
class StaffListTable extends React.Component {
  render() {
    const {
      classes,
      order,
      orderBy,
      selected,
      rowsPerPage,
      page,
      data,
      handleRequestSort,
    } = this.props;

    return (
      <div className={classes.tableWrapper}>
        <Table className={classes.table}>
          {/* aria-labelledby="tableTitle" */}
          <StaffListTableHead
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={data.length}
          />
          <TableBody>
            {data.map(n => (
              <TableRow
                hover
                role="checkbox"
                tabIndex={-1}
                key={n.firstName + n.lastName}
                className={classes.row}
              >
                <TableCell
                  className={classes.cell}
                  component="th"
                  scope="row"
                  padding="none"
                >
                  {n.siteName}
                </TableCell>
                <TableCell className={classes.cell} padding="none" numeric>
                  {n.ncesId}
                </TableCell>
                <TableCell className={classes.cell} padding="none">
                  {n.firstName}
                </TableCell>
                <TableCell className={classes.cell} padding="none">
                  {n.lastName}
                </TableCell>
                <TableCell className={classes.cell} padding="none">
                  {n.email}
                </TableCell>
                <TableCell className={classes.cell} padding="none">
                  {n.userType}
                </TableCell>
                <TableCell className={classes.cell} padding="checkbox">
                  {isTrue(n.adminRole) ? <Check /> : <div />}
                </TableCell>
                <TableCell className={classes.cell} padding="checkbox">
                  {isTrue(n.approverRole) ? <Check /> : <div />}
                </TableCell>
                <TableCell className={classes.cell} padding="checkbox">
                  {isTrue(n.uploaderRole) ? <Check /> : <div />}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default withStyles(styles)(StaffListTable);



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/staff/components/StaffListTable.jsx